import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import type { UnitOfMeasure } from '@ztechapps/common.contract'
import { unitOfMeasureQueries } from '../graphql'

/**
 * Get all unit of measures from the database
 */
export const useUnitOfMeasureList = (props: Partial<UseListProps> = {}): UseListResult<UnitOfMeasure> => {
  return useList<UnitOfMeasure>({
    ...unitOfMeasureQueries.allConfig,
    limit: 0,
    ...props,
  })
}
